import { useState, useEffect, useRef } from "react";
import { getScreenSize, sizeEqualOrLessThan } from "utils/helpers";
export default function useScreenSize() {
	if (typeof window === "undefined") return {};
	const _size = getScreenSize();
	const [width, setWidth] = useState(window.innerWidth);
	const [size, setSize] = useState(_size);
	const timer = useRef(null);
	// const sizes = useRef(["xs", "sm", "md", "lg", "xl", "xxl"]);

	function updateWidth() {
		const w = window.innerWidth;
		clearTimeout(timer.current);
		timer.current = setTimeout(() => {
			setWidth(w);
			setSize(getScreenSize());
		}, 100);
	}

	useEffect(() => {
		updateWidth();
		setSize(getScreenSize());
		window.addEventListener("resize", updateWidth);
		return () => window.removeEventListener("resize", updateWidth);
	}, []);

	return { width, size };
}
